// extracted by mini-css-extract-plugin
module.exports = {"text":"buttonLink__text--3F4-o","secondary":"buttonLink__secondary--30Z3h"};